import { DefaultValue, selectorFamily } from 'recoil';
export const triStateTypeToBooleanSelectorFamily = selectorFamily({
    key: 'utils/triStateTypeToBoolean',
    get: (selector) => ({ get }) => {
        const triState = get(selector);
        if (triState) {
            return triState === 'true';
        }
        return false;
    },
    set: (selector) => ({ set }, value) => {
        set(selector, value instanceof DefaultValue
            ? 'unset'
            : value === true
                ? 'true'
                : 'false');
    },
});
export const booleanToTriStateTypeSelectorFamily = selectorFamily({
    key: 'utils/booleanToString',
    get: (selector) => ({ get }) => {
        const value = get(selector);
        if (value) {
            return 'true' === value ? true : false;
        }
        return false;
    },
    set: (selector) => ({ set }, value) => {
        set(selector, value instanceof DefaultValue ? 'unset' : value ? 'true' : 'false');
    },
});
